module.exports = __webpack_public_path__ + "static/media/2008.4a4941d1.csv";